export default __webpack_public_path__ + "static/media/fts.aa27715b.webp";